module.exports = __webpack_public_path__ + "img/saum_hellelfenbein_ral1015.6fb411a7.jpg";